import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "c-report-poster-share"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "share-item-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.apiList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["share-item", item.name === 'CopyUrl' ? 'btn-copy-link' : '']),
      key: item.id,
      onClick: function onClick($event) {
        return $options.openAppShare(item);
      }
    }, [_createElementVNode("img", {
      class: "share-item-icon",
      src: item.icon
    }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString(item.label), 1)], 10, _hoisted_2);
  }), 128))]);
}